import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from './models/api-response';
import { GenericItem } from './models/generic-item';
import { SystemChargePlanSetting } from './models/system-charge-plan-setting';

import { ServicerProvider } from './servicer';

const BASE_URL = '/v2/system/chargePlan';

/**
 * [システム] 充電計画 のプロバイダー.
 */
@Injectable()
export class SystemChargePlanServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * 設定情報を取得.
   * 
   * @returns Observable<SystemChargePlanSetting>
   */
  getSetting(): Observable<GenericItem<SystemChargePlanSetting>> {
    const url = `${BASE_URL}/setting`;
    return this.servicer.get<GenericItem<SystemChargePlanSetting>>(url);
  }

  /**
   * 設定情報更新.
   *
   * @param data 入力データ
   * @returns Observable<ApiResponse>
   */
  updateSetting(data: SystemChargePlanSetting): Observable<ApiResponse> {
    const url = `${BASE_URL}/setting`;
    return this.servicer.postApi<SystemChargePlanSetting, ApiResponse>(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-charge-plan-service.ts